import { LenientWindow } from '../../types/LenientWindow';
import getClosestHTMLElement from './getClosestHTMLElement';
import { getTouchLocation } from './getTouchLocation';
import Renderer from './Renderer';

declare let window: LenientWindow;

// When doing a single tap with the stylus, `touchmove` still fires multiple times
// This is a workaround to ignore these events
export const isActuallyMovingWithStylus = ({ touchFromStylus, startTouchClientY }: {touchFromStylus: Touch; startTouchClientY: number;}) => {
  const totalMovement = Math.abs(startTouchClientY - touchFromStylus.clientY);
  return totalMovement > 5;
};

// Ignore means the behaviour will be the same as when using your finger
export function shouldIgnoreStylusTouchInThisTarget(event: TouchEvent) {
  if (!window.isAutoHighlightingEnabled) {
    return true;
  }

  const target = getClosestHTMLElement(event.target as Node);

  if (!target) {
    return true;
  }

  const isResizingHighlight = Boolean(target.closest(`.${Renderer.highlightResizeHandleClassName}`));
  const isTargetInHighlight = target.tagName.toLowerCase() === Renderer.textHighlightTagName || target.classList.contains(Renderer.imageHighlightClassName);

  if (isResizingHighlight || isTargetInHighlight) {
    return true;
  }

  const isElementInsideAChunkContainer = target.closest('.rw-chunk-container') !== null;

  if (isElementInsideAChunkContainer) {
    return getTouchLocation(event) === 'padding';
  }

  return true;
}
